import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Currency } from '@sorare/core/src/__generated__/globalTypes';
import { AccountEntry } from '@sorare/core/src/components/mySorare/TransactionsHistory/UserAccountEntries/AccountEntry';
import { isType } from '@sorare/core/src/lib/gql';

import type { PrimaryOffer_userAccountEntry } from './__generated__/index.graphql';
import { TransactionsPrimaryOffer } from '../../common/TransactionsPrimaryOffer';
import { TransactionsPrimaryOfferTitle } from '../../common/TransactionsPrimaryOffer/Title';

type Props = {
  userAccountEntry: PrimaryOffer_userAccountEntry;
  primaryCurrency: Currency;
};

export const PrimaryOffer = ({ userAccountEntry, primaryCurrency }: Props) => {
  const { tokenOperation } = userAccountEntry;

  if (!isType(tokenOperation, 'TokenPrimaryOffer')) {
    return null;
  }

  return (
    <AccountEntry
      userAccountEntry={userAccountEntry}
      title={
        <TransactionsPrimaryOfferTitle tokenPrimaryOffer={tokenOperation} />
      }
      primaryCurrency={primaryCurrency}
    >
      <TransactionsPrimaryOffer tokenPrimaryOffer={tokenOperation} />
    </AccountEntry>
  );
};

PrimaryOffer.fragments = {
  userAccountEntry: gql`
    fragment PrimaryOffer_userAccountEntry on UserAccountEntry {
      id
      tokenOperation {
        ... on TokenPrimaryOffer {
          id
          ...TransactionsPrimaryOffer_tokenPrimaryOffer
          ...TransactionsPrimaryOfferTitle_tokenPrimaryOffer
        }
      }
      ...AccountEntry_userAccountEntry
    }
    ${AccountEntry.fragments.userAccountEntry}
    ${TransactionsPrimaryOffer.fragments.tokenPrimaryOffer}
    ${TransactionsPrimaryOfferTitle.fragments.tokenPrimaryOffer}
  ` as TypedDocumentNode<PrimaryOffer_userAccountEntry>,
};
